import React, { Component } from 'react';
import './About.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

class About extends Component {
    render() {
        return (
            <div id="apropos">
                <div className="about_container">

                    <div className="about_image">
                        <img src={process.env.PUBLIC_URL + "/assets/img/me.jpg"} alt="Nicolas Tremblay" />
                    </div>

                    <div className="about_text">
                        <h1>Nicolas Tremblay</h1>
                        <h2>Développeur mobile & web</h2>
                        <a href="https://www.linkedin.com/in/nicolas-tremblay-45055765/" className='social_button_container' target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon className='social_button' icon={faLinkedinIn} />
                        </a>
                        <p>Je suis développeur spécialisé en applications mobiles et web. J’utilise <strong>.NET (MAUI, ASP.NET)</strong> et les technologies natives comme <strong> Swift, Objective-C, Kotlin et Java</strong> pour créer des solutions performantes et durables.</p>
                        <p>J’aime aussi m’impliquer dans des projets de gestion et de conception. En dehors du travail, je suis intéressé par l’agriculture et le patrimoine.</p>
                    </div>

                    <div className="contact_button">
                        <a href="#" onClick={() => window.location = "mailto:" + "nicolas" + "@lacerta.ca"}>
                            Me contacter
                        </a>
                    </div>

                </div>
            </div>
        )
    }
}

export default About;
